const data = require("./postnummer.json");
export const findPoststed = (postnummer: string) => {
  const entry = data.find((entry: POST) => entry.nummer === postnummer);
  return entry ? entry.sted : undefined;
};

type POST = {
  nummer: string;
  sted: string;
};
